import routes from 'global/Constants/routes';
import { lazy } from 'react';

const termsAndConditions = lazy(() => import('../../pages/dashboard/termsAndConditions/TermsAndConditions'));

const footerTermsAndCondition = lazy(() => import('../../pages/home/footerTermsAndCondition/footerTermsAndCondition'));

export const termsAndConditionsRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.termsAndConditions.path,
    component: termsAndConditions,
    isPrivate: routes.termsAndConditions.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.footerTermsAndCondition.path,
    component: footerTermsAndCondition,
    isPrivate: routes.footerTermsAndCondition.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
